import logoutUtil from "../utils/logout";

const logout = ({ timeout = 100 } = {}) => next => action => {
  const result = next(action);
  if (result && result.error) {
    if (result.error.code === 401) {
      setTimeout(logoutUtil, timeout);
    }
  }
  return result;
};

export default logout;
